/* global jarallax */

import 'jarallax/dist/jarallax'
import each from 'lodash/each'

function setupParallaxOnEl(el) {
  jarallax(el, { speed: 0.5 })
}

function setupParallax(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('.parallax')
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupParallaxOnEl(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll('.parallax')
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupParallaxOnEl(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

// eslint-disable-next-line import/prefer-default-export
export { setupParallax }
